var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesDocumentationIcon = function SvgResourcesDocumentationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 82,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFFFFD",
    strokeLinejoin: "bevel",
    strokeWidth: 20,
    d: "M78 9 22 38l70.256 19L2 72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#44B58F",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M70.043 32.63V70.5H29.957v-49h28.956z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#44B58F",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M70.043 32.63v2.24h-13.37V21.5h2.24zM47.783 48.217h4.434M56.673 48.217h4.457M38.87 48.217h4.457"
  })));
};
export default SvgResourcesDocumentationIcon;